import {

  cms_article_first,
  cms_article_focuses,
  cms_adverts,
  cms_nodeCodeInfo,
  loc_getSiteSubset,
  auction_hall,
  cms_node_subsets,
  cms_batch_nodes
} from '@/api/portal'
import { uuid } from '@/utils'
import store from '@/store'

const state = {

  cmsProblemNode: null, // 常见问题节点

  cmsNoticeNode: null, // 公告节点
  noticeArticle: [], // 公告文章

  cmsNewsNode: null, // 新闻资讯节点
  newsArticle: null, // 新闻文章

  friendlyLink: null, // 友情链接数据
  registerProtocol: {}, // 用户注册须知
  bidding: null, // 竞买须知
  focusesData: null, // 焦点轮播数据

  indexAdverts: null, // 首页广告

  // bidHallData:[],//

  targetType: [], // 标的类型
  areaInfo: [], // 所在区域
  projectBigHall: null, // 竞拍大厅数据

  nodeSubsets: [], // 子级栏目数据集合（只包含第一个子栏目文章数据，适用于tabs）

  childNodesData: [], // 子级栏目数据
  allAdvert: [],

  activeCmsNode: null // 当前选中的栏目

}

const mutations = {

  findActiveCmsNode(state, route) {
    console.log('findActiveCmsNode', store)
  }
}

const actions = {

  // 初始子级栏目数据
  async initNodeSubsets({ state }, params) {
    if (!state.nodeSubsets.length) {
      const { data } = await cms_node_subsets(params)
      state.nodeSubsets = data
    }
  },

  // 初始子级栏目数据
  async initChildNodesData({ state }, params) {
    if (!state.childNodesData.length) {
      const { data } = await cms_batch_nodes(params)
      state.childNodesData = data
    }
  },

  // 初始竞拍大厅数据
  async initProjectBigHall(store, { params, refresh }) {
    if (!store.state.projectBigHall || refresh) {
      console.log('params', params)
      params.uid = uuid(13)
      const { data } = await auction_hall(params)
      store.state.projectBigHall = data
      if (!data) {
        store.state.projectBigHall = {
          list: [],
          pageNum: 0,
          pageSize: 0,
          total: 0
        }
      }
    }
  },

  // 初始竞拍大厅所在区域
  async initAreaInfo(store) {
    if (!store.state.areaInfo.length) {
      const { data } = await loc_getSiteSubset()
      store.state.areaInfo = data
    }
  },

  // 初始常见问题node
  async initProblemNode(store) {
    if (!store.state.cmsProblemNode) {
      const { data } = await cms_nodeCodeInfo({ code: 'problem' })
      store.state.cmsProblemNode = data
    }
  },
  // 初始通知公告node
  async initNoticeNode(store) {
    if (!store.state.cmsNoticeNode) {
      const { data } = await cms_nodeCodeInfo({ code: 'notice' })
      store.state.cmsNoticeNode = data
    }
  },

  // 初始首页广告
  async initIndexAdverts(store, loc) {
    if (!store.state.indexAdverts) {
      const { data } = await cms_adverts({ loc })
      store.state.indexAdverts = data
    }
  },
  // 获取用户注册须知
  async initRegisterProtocol(store) {
    const { data } = await cms_article_first({ code: 'protocol' })
    store.state.registerProtocol = data
  },
  // 获取竞买须知
  async initBidding(store) {
    const { data } = await cms_article_first({ code: 'bidding' })
    store.state.bidding = data
  },
  // 获取焦点数据
  async initFocusesData(store) {
    if (!store.state.focusesData) {
      const { data } = await cms_article_focuses({ codes: 'dtnews,dfnews,trend,recommend', rows: 5 })
      store.state.focusesData = data
    }
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}

